import React, {useEffect, useRef, useState} from "react";
import socket from "./utils/clientSocket";
import {gameState} from "./components/Game";

const ChessClock = (props) => {
    const lastUpdate = useRef(null);
    const latestTurn = useRef(props.turn);
    const interval = useRef(null);

    const color = useRef(props.color);
    const [timeLeft, setTimeLeft] = useState(props.gameLength);

    const countDown = () => {
        const newUpdate = Date.now();
        const elapsed = newUpdate - lastUpdate.current;
        if (latestTurn.current === color.current) {
            setTimeLeft((prevState) => prevState - elapsed);
            lastUpdate.current = newUpdate;
        }
    };

    //This is necessary, because the setInterval method only runs the countdown method with the EXACT VALUES SPECIFIED
    //during the setInterval call. Therefore, we need to listen to changes to the turn variable, and update our ref value,
    //as this is the only change the setInterval can see

    useEffect(() => {
        latestTurn.current = props.turn;
        color.current = props.color
    }, [props.turn, props.color]);

    useEffect(() => {
        if (props.gameState === gameState.IN_PROGRESS) {
            lastUpdate.current = Date.now();
            setTimeLeft(props.gameLength);
            interval.current = setInterval(countDown, 100);
            return () => {
                clearInterval(interval.current);
            };
        }

        if (props.gameState === gameState.FINISHED) {
            clearInterval(interval.current);
        }

    }, [props.gameState, props.gameLength]);

    useEffect(() => {
        const handleTimeLeft = ({timeLeft}) => {
            setTimeLeft(timeLeft[color.current]);
            lastUpdate.current = Date.now();
        };

        socket.on("update", handleTimeLeft);
        return () => {
            socket.off("update", handleTimeLeft);
        };
    }, []);

    const convertDateToString = (date) => {
        if (date < 0) {
            return "0m 0s";
        }
        const minutes = Math.floor(date / 60000);
        const seconds = Math.floor(date / 1000) % 60;
        return `${minutes}m ${seconds}s`;
    };

    return (
        <div style={props.style}>
            <div style={{marginBottom: "1.25rem", textAlign: "center"}}>
                <p className="clock">{convertDateToString(timeLeft)}</p>
            </div>
        </div>
    );
};

export default ChessClock;

